module.exports = __webpack_public_path__ + "static/media/woman-smiling-and-eating-outside-the-pop-porium-shop-2434048.995b25fc.jpg";